import { api } from '@/lib/api'

export interface FactuurRegel {
  inkoopfactuurnr: string
  crediteur: string
  crediteurnummer: string
  voorraad: number
  emballage: number
  verpakkingen: number
  overig: number
  waarderingsom: number
  betaalstatus: 'Open' | 'Betaald' | 'Deelbetaling'
  deelbetaling_bedrag: number
  factuurdatum: string | null
  vervaldatum: string | null
  betaaldatum: string | null
  deductie: number
  deductiereden: string
  waarderingsom_financierbaar: number
}

export interface FinancierbaarOverzicht {
  organisation_id: number
  organisation_naam: string
  waarderingsom_totaal: number
  deductiesom_totaal: number
  waarderingsom_financierbaar_totaal: number
  facturen: FactuurRegel[]
}

export interface BetalingUpdate {
  inkoopfactuurnummer: string
  betaalstatus: 'Open' | 'Betaald' | 'Deelbetaling'
  deelbetaling_bedrag: number
  factuurdatum?: string | null
  vervaldatum?: string | null
  betaaldatum?: string | null
  opmerkingen?: string | null
}

export const fetchFinancierbaar = (orgId: number) =>
  api.get<FinancierbaarOverzicht>(`/api/financierbaar/${orgId}`).then(r => r.data)

export const bulkUpdateBetalingen = (orgId: number, wijzigingen: BetalingUpdate[]) =>
  api.put<{ gewijzigd: number; nieuw: number }>(
    `/api/financierbaar/${orgId}/betalingen`,
    { wijzigingen }
  ).then(r => r.data)
